import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import React from "react";

const AllocationFilter: React.FC<any> = (props) => {
  const { onChange } = props;
  const isSR = process.env.REACT_APP_COMPANY_CODE === "SNR";

  return (
    <Box>
      <FormControl fullWidth>
        {/* <InputLabel htmlFor="">Type</InputLabel> */}
        <Select
          native
          onChange={onChange}
          inputProps={{
            name: "type",
            id: "",
          }}
        >
          <option value="">All</option>
          <option value="implant">{isSR ? "Consumable" : "Implant"}</option>
          <option value="instrument">{isSR ? "Device" : "Instrument"}</option>
          <option value="other">Additional/Others</option>
        </Select>
      </FormControl>
    </Box>
  );
};

export default AllocationFilter;
